<script setup lang="ts">
import { type AchievementItem, AchievementType } from '@/types/achievements'
import { computed } from 'vue'
import AchievementCard from '@/components/AchievementCard.vue'
import { useAchievements } from '@/composables/game/achievements'
import { useSlider } from '@/composables/helpers/slider'

const props = defineProps<{
	category: AchievementType
	cards: AchievementItem[]
	currentValue: number
  maxLevels: number | null | undefined
}>()

const { onMouseDown, onMouseUp, onMouseMove, slider } = useSlider()

const { newlyAchievedMilestones, getLatestMilestone } = useAchievements()

// Only show first max levels (hide higher levels for now)
const filteredCards = computed(() => props.maxLevels ? props.cards.slice(0, props.maxLevels) : props.cards)

</script>

<template>
  <div
    ref="slider"
    class="-mx-4 card-slider flex gap-x-2 overflow-x-auto select-none pt-2 -mt-1"
    @mousedown="onMouseDown"
    @mouseup="onMouseUp"
    @mouseleave="onMouseUp"
    @mousemove="onMouseMove"
  >
    <div
      v-for="(card, index) in filteredCards"
      :key="index"
      class="flex-none"
      :class="{'pl-4 w-[106px]': index === 0, 'pr-4 w-[106px]' : index === filteredCards.length - 1, 'w-[90px]': index > 0 &&
        index < filteredCards.length - 1}"
    >
      <AchievementCard
        class="w-full"
        :card="card"
        :owned="currentValue >= card.number"
        :is-previous-owned="index > 0 ? currentValue >= filteredCards[index-1].number : !(card.number === getLatestMilestone(category)?.number && newlyAchievedMilestones[category] === true)"
        :is-new="card.number === getLatestMilestone(category)?.number && newlyAchievedMilestones[category] === true"
        :current-value="currentValue"
        :category-id="category"
      />
    </div>
  </div>
</template>

<style scoped>
.card-slider::-webkit-scrollbar {
	display: none; /* Hide scrollbar for WebKit browsers */
}

.card-slider {
	-ms-overflow-style: none; /* Hide scrollbar for IE/Edge */
	scrollbar-width: none; /* Hide scrollbar for Firefox */
}
</style>
